const handleSubmitSearch = (event, status, payload, dispatch) => {
  event.preventDefault();
  status.setPage(1);
  status.setHasMoreItems(true);
  dispatch({ type: "REPLACE", payload });
};

export default handleSubmitSearch;
